import type { TaskActivity } from "apprentices/task-activity";
import { executionSchema } from "playground/migrations/contract";

export type TaskStatus = "open" | "applied" | "completed" | "archived";
export type WorkshopSection =
  | "attention"
  | "working"
  | "open"
  | "completed"
  | "hidden";

/** A task can be authored through files or scripts before its chat ever runs. */
export function canReviewTask(activity: TaskActivity | null): boolean {
  return activity === "not_started" || activity === "settled";
}

export function workshopTaskState(
  task: { status: TaskStatus; migration: unknown },
  activity: TaskActivity | null | undefined,
): { section: WorkshopSection; label: string } {
  if (task.status === "archived")
    return { section: "hidden", label: "Archived" };
  if (task.status === "applied" && task.migration !== null) {
    switch (executionSchema.parse(task.migration).state.status) {
      case "pending":
        return { section: "attention", label: "Action not started" };
      case "running":
        return { section: "working", label: "External action running" };
      case "submitting":
        return { section: "attention", label: "Submission unconfirmed" };
      case "submitted":
        return { section: "working", label: "External action processing" };
      case "failed":
        return { section: "attention", label: "External action failed" };
      case "unknown":
        return { section: "attention", label: "External result uncertain" };
      case "differed":
        return { section: "attention", label: "Done, differs from preview" };
      case "succeeded":
        return { section: "completed", label: "Completed" };
    }
  }
  if (task.status === "applied" || task.status === "completed")
    return { section: "completed", label: "Completed" };
  switch (activity) {
    case "needs_input":
      return { section: "attention", label: "Needs input" };
    case "settled":
      return { section: "attention", label: "Ready for review" };
    case "working":
      return { section: "working", label: "Agent working" };
    case "not_started":
      return { section: "open", label: "Open" };
    default:
      return { section: "open", label: "Checking status" };
  }
}
